export type SupportedLanguage = 'en' | 'es' | 'fr' | 'de' | 'it' | 'pt' | 'ru' | 'zh' | 'ja' | 'ar' | 'he';

export interface TranslationKeys {
  betBuilder: {
    title: string;
    noBetsSelected: string;
    totalOdds: string;
    clearAll: string;
    removeBet: string;
    addBet: string;
    event: string;
    market: string;
    selection: string;
    odds: string;
    confirmClear: string;
    confirmClearMessage: string;
    cancel: string;
    confirm: string;
    totalSelections:string;
    addSelections: string;
    closed: string;
    suspend: string;
    eventClosed: string;
    eventSuspended: string;
    buildABet:string;
    
  };
  betStatus: {
    won: string;
    pending: string;
    refund: string;
    lost: string;
    halfwon: string;
    halflost: string;
    cashout: string;
    unknown: string;
  };
  common: {
    loading: string;
    error: string;
    retry: string;
    close: string;
    save: string;
    edit: string;
    delete: string;
    back: string;
    next: string;
    previous: string;
    search: string;
    filter: string;
    sort: string;
    settings: string;
  };
  errors: {
    generic: string;
    network: string;
    notFound: string;
    unauthorized: string;
    validation: string;
  };
}

export const RTL_LANGUAGES: SupportedLanguage[] = ['ar', 'he'];

export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  it: 'Italiano',
  pt: 'Português',
  ru: 'Русский',
  zh: '中文',
  ja: '日本語',
  ar: 'العربية',
  he: 'עברית'
};

export const LANGUAGE_FLAGS: Record<SupportedLanguage, string> = {
  en: '🇺🇸',
  es: '🇪🇸',
  fr: '🇫🇷',
  de: '🇩🇪',
  it: '🇮🇹',
  pt: '🇵🇹',
  ru: '🇷🇺',
  zh: '🇨🇳',
  ja: '🇯🇵',
  ar: '🇸🇦',
  he: '🇮🇱'
};